export function getProjects(arr) {
  const serverUrl = "https://pro-wellness.ru:9443"; // путь к серверу

  const projectsAll = arr.map((item, index) => {
    const project = item;
    return {
      id: project.id,
      title: project.title,
      description: project.description,
      baner: serverUrl + project.baner.data.attributes.url,
      banerAlt: project.baner.data.attributes.alternativeText,
      city: project.characteristic.city,
      year: project.characteristic.year,
      stage: project.characteristic.stage,
      projectDescription: project.projectDescription,
      list: project.list,
      topPhoto: serverUrl + project.detail.topPhoto.data.attributes.url,
      topPhotoAlt: project.detail.topPhoto.data.attributes.alternativeText,
      bottomPhoto: serverUrl + project.detail.bottomPhoto.data.attributes.url,
      bottomPhotoAlt:
        project.detail.bottomPhoto.data.attributes.alternativeText,
      otherPhoto: project.otherPhotos.otherPhotos.data,
    };
  });
  return projectsAll;
}
